import { render, staticRenderFns } from "./show.vue?vue&type=template&id=259c74c8&scoped=true&"
import script from "./show.vue?vue&type=script&lang=ts&"
export * from "./show.vue?vue&type=script&lang=ts&"
import style0 from "./show.vue?vue&type=style&index=0&id=259c74c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259c74c8",
  null
  
)

export default component.exports